import React, { useContext, useEffect } from 'react';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { estadoCivil, sexo, tipoDocumentos } from '../../data/mochaData';
import useToken from '../../hooks/useToken';
import { tipoId } from '../../utils/constanst';
import BirthDateControl from '../controls/BirthDateControl';
import CustomSelect from '../controls/CustomSelect';
import DateControl from '../controls/DateControl';
import DropDownInput from '../controls/DropDownInput';
import Input from '../controls/Input';
import InputFile from '../controls/InputFile';
import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';

const Step4 = ({ ...rest }) => {



    const { poliza, setPoliza, polizaChangeHandler } = useContext(CotizadorCRDataContext);


    return (
        <div className="reponsive">
            <div className="reponsive-width-6">
                <div className='box-pl5-pr5'>
                    <Input label='Nombre del cónyuge' field='nombreConyuge' value={poliza.nombreConyuge} onChange={polizaChangeHandler} />
                </div>
            </div>
            <div className="reponsive-width-6">
                <div className='box-pl5-pr5'>
                    <Input label='Apellidos del cónyuge' field='apellidoConyuge' value={poliza.apellidoConyuge} onChange={polizaChangeHandler} />
                </div>
            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">

                    <InputSelect label='Profesión' containBlank={true} value={poliza.profesionConyuge} field='profesionConyuge' dataProvider='profesion' onChange={polizaChangeHandler} />

                    {poliza.tipoIdConyuge === tipoId.cedula &&

                        <DropDownInput label='Número de identificación' dataProvider={tipoDocumentos}
                            value={poliza.identificacionConyuge} onChange={polizaChangeHandler}
                            valueSelect={poliza.tipoIdConyuge} onChangeSelect={polizaChangeHandler}
                            field='identificacionConyuge'
                            fieldSelect='tipoIdConyuge'
                            mask="9-9999-9999"
                            pattern="\d-\d\d\d\d-\d\d\d\d"
                            title="Documento invalido"
                        />
                    }

                    {poliza.tipoIdConyuge !== tipoId.cedula &&

                        <DropDownInput label='Número de identificación' dataProvider={tipoDocumentos}
                            value={poliza.identificacionConyuge} onChange={polizaChangeHandler}
                            valueSelect={poliza.tipoIdConyuge} onChangeSelect={polizaChangeHandler}
                            field='identificacionConyuge'
                            fieldSelect='tipoIdConyuge'
                            title="Documento invalido"
                        />
                    }

                    <Input label='Número de celular' pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' type='maskInput' mask='9999-9999' field='telefonoCelularConyuge' placeholder='0000-0000' value={poliza.telefonoCelularConyuge} onChange={polizaChangeHandler} classNameContainer='w100' classNameInput='w100' />


                </div>
            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">

                    <Input label='Lugar de nacimiento' field='lugarNacConyuge' value={poliza.lugarNacConyuge} onChange={polizaChangeHandler} />
                    <BirthDateControl label='Fecha de nacimiento' value={poliza.fechaNacimientoConyuge} onChange={date => setPoliza({ ...poliza, fechaNacimientoConyuge: date })} />

                    <InputSelect label='País de origen' value={poliza.paisConyuge} field='paisConyuge' dataProvider='paises' onChange={polizaChangeHandler} />

                </div>
            </div>
        </div>
    );
}

export default Step4;
